module.exports = __webpack_public_path__ + "img/s28.e42621e.png";